// src/components/ShopCard.jsx

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Row, Col, Card, Button } from 'react-bootstrap';
import { 
  FaStar, FaStarHalfAlt, FaRegStar, FaMapMarkerAlt, 
  FaCheckCircle, FaBox 
} from 'react-icons/fa';
import '../../../../assets/css/user/shoppage/shopcard/ShopCard.css';

const ShopCard = ({ shop }) => {
  const navigate = useNavigate();

  // Render star rating
  const renderStars = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;
    
    for (let i = 0; i < fullStars; i++) {
      stars.push(<FaStar key={`full-${i}`} className="star-icon filled" />);
    }
    if (hasHalfStar) {
      stars.push(<FaStarHalfAlt key="half" className="star-icon filled" />);
    }
    const emptyStars = 5 - Math.ceil(rating);
    for (let i = 0; i < emptyStars; i++) {
      stars.push(<FaRegStar key={`empty-${i}`} className="star-icon" />);
    }
    return stars;
  };

  // Navigate to shop page
  const handleVisitShop = () => {
    navigate(`/shop/${shop.id}`);
  };

  // Handle contact shop
  const handleContactShop = () => {
    // You can open modal or navigate to contact page
    window.location.href = `mailto:${shop.email}`;
  };

  return (
    <Card className="shop-card">
      <Row className="g-0">
        {/* Shop Banner & Logo Section */}
        <Col md={4}>
          <div className="shop-image-section">
            <div 
              className="shop-banner-img"
              style={{backgroundImage: `url(${shop.banner})`}}
            >
              <div className="banner-overlay"></div>
            </div>
          </div>
        </Col>

        {/* Shop Info Section */}
        <Col md={5}>
          <Card.Body className="shop-info-body">
            <div className="shop-header">
              <h3 className="shop-name">
                {shop.name}
                {shop.verified && (
                  <FaCheckCircle className="verified-icon" title="Verified" />
                )}
              </h3>
              <span
  className={`category-badge ${
    shop.category === "Premium"
      ? "badge-premium"
      : "badge-standard"
  }`}
>
  {shop.category}
</span>
            </div>

            <div className="shop-rating">
              <div className="stars-display">
                {renderStars(shop.rating)}
              </div>
              <span className="rating-text">
                <strong>{shop.rating}</strong> ({shop.totalReviews} reviews)
              </span>
            </div>

            <p className="shop-description">{shop.description}</p>

            <div className="shop-meta-info">
              <div className="meta-item">
                <FaMapMarkerAlt className="meta-icon" />
                <span>{shop.location}</span>
              </div>
              <div className="meta-item">
                <FaBox className="meta-icon" />
                <span>{shop.totalProducts}+ Products</span>
              </div>
            </div>

            {/* Featured Products Preview */}
            <div className="featured-products">
              <small className="featured-label">Featured Equipment:</small>
              <div className="featured-images">
                {shop.featuredProducts.map((product, index) => (
                  <div key={index} className="featured-item" title={product.name}>
                    <img src={product.image} alt={product.name} />
                  </div>
                ))}
              </div>
            </div>
          </Card.Body>
        </Col>

        {/* Action Section */}
        <Col md={3}>
          <div className="shop-action-section">
            <Button className="card-visit-shop-btn" onClick={handleVisitShop}>
              Visit Shop
            </Button>
            <Button variant="outline" className="contact-btn" onClick={handleContactShop}>
              Contact Shop
            </Button>
            <div className="quick-stats">
              <div className="stat-item">
                <span className="stat-number">{shop.totalProducts}+</span>
                <span className="stat-label">Products</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">{shop.rating}</span>
                <span className="stat-label">Rating</span>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Card>
  );
};

export default ShopCard;